export class Banner {
  id: number;
  desktopImageUrl: string;
  mobileImageUrl: string;
  desktopVideoUrl: string;
  mobileVideoUrl: string;
  altText: string;
  linkUrl: string;
  videoUrl: string;
  videoUrlMobile: string;
  type: 'picture' | 'content' | 'video' | 'desktop_video' | 'mobile_video'; // see SliderTypeEnum
  queryParams: any;
  position: number;
  content: string;
  class: string;
}
